import { motion } from 'motion/react'
import { SVGProps } from 'react'

interface AnimatedIconProps extends SVGProps<SVGSVGElement> {
	isActive?: boolean
	showDot?: boolean
}

export default function AnimatedDotBubbleIcon({
	isActive = false,
	showDot = false,
	...props
}: AnimatedIconProps) {
	return (
		<svg
			width="28"
			height="28"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g>
				<motion.path
					d="M20.7002 11.6723C20.7037 13.0189 20.3891 14.3473 19.7819 15.5493C19.0621 16.9897 17.9554 18.2012 16.5859 19.0481C15.2164 19.895 13.6381 20.3439 12.0279 20.3446C10.6813 20.3481 9.35288 20.0334 8.15089 19.4263L3.2002 20.7829L4.27388 15.5493C3.66675 14.3473 3.35213 13.0189 3.35564 11.6723C3.35627 10.0621 3.80518 8.48381 4.65211 7.1143C5.49904 5.7448 6.71054 4.63813 8.15089 3.91827C9.35288 3.31114 10.6813 2.99652 12.0279 3.00003H12.538C14.6646 3.11735 16.6732 4.01495 18.1792 5.52096C19.6852 7.02698 20.5828 9.03557 20.7002 11.1622V11.6723Z"
					fill="none"
					stroke="var(--tint-primary)"
					strokeWidth="1.8"
					strokeLinecap="round"
					strokeLinejoin="round"
					animate={{
						fill: isActive ? 'var(--tint-primary)' : 'rgba(0, 0, 0, 0)',
					}}
					transition={{
						duration: 0.2,
					}}
				/>
				<motion.circle
					cx="19"
					cy="5"
					r="4"
					fill="rgba(0, 0, 0, 0)"
					strokeWidth="2"
					animate={{
						stroke: showDot ? 'rgba(255, 255, 255, 1)' : 'rgba(0, 0, 0, 0)',
						fill: showDot ? '#FFD001' : 'rgba(0, 0, 0, 0)',
					}}
					transition={{
						duration: 0.2,
					}}
				/>
			</g>
		</svg>
	)
}
